export const DY_SERVER_SIDE_API_BASE_URL = 'https://dy-api.eu/v2';
export const DY_CLIENT_SIDE_API_BASE_URL = 'https://direct.dy-api.eu/v2';
export const DY_CLIENT_SIDE_API_COLLECT_BASE_URL = 'https://direct-collect.dy-api.eu/v2';

export const CHOOSE_ENDPOINT = '/serve/user/choose';
export const EVENTS_ENDPOINT = '/collect/user/event';
export const ENGAGEMENTS_ENDPOINT = '/collect/user/engagement';
export const PAGEVIEW_ENDPOINT = '/collect/user/pageview';

export const COOKIES = {
  dyId: '_dyid',
  dyServerId: '_dyid_server',
  dySession: '_dyjsession',
};
